import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MuiButton from "@material-ui/core/Button";
import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import successIcon from "../../../../assets/icons/SuccessIcon.svg";

type SuccessDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  title: string;
};

const StyledDialog = styled(Dialog)(({ theme }: { theme: Theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 10,
    border: `1px solid ${theme.palette.brand.gray200}`,
    padding: "8px 0",
    minWidth: 360,
  },
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }: { theme: Theme }) => ({
  "& .MuiTypography-root": {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.brand.gray900,
  },
}));

const StyledDialogContent = styled(DialogContent)({
  display: "flex",
  justifyContent: "center",
  padding: "16px 24px",
});

const SuccessIconImg = styled("img")({
  width: 80,
  height: 80,
});

const DoneButton = styled(MuiButton)(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.coral,
  color: theme.palette.brand.white,
  fontSize: 13,
  fontWeight: 600,
  padding: "8px 24px",
  borderRadius: 8,
  textTransform: "none",
  boxShadow: "none",
  minWidth: "unset",
  "&:hover": {
    background: theme.palette.brand.coralHover,
    transform: "translateY(-1px)",
    boxShadow: "none",
  },
}));

const SuccessDialog: FC<SuccessDialogProps> = ({ isOpen, handleClose, title }) => {
  return (
    <StyledDialog open={isOpen} onClose={handleClose} aria-labelledby="success-dialog-title">
      <StyledDialogTitle id="success-dialog-title">{title}</StyledDialogTitle>
      <StyledDialogContent>
        <SuccessIconImg src={successIcon} alt="Success" />
      </StyledDialogContent>
      <DialogActions style={{ padding: "8px 24px 16px" }}>
        <DoneButton onClick={handleClose} disableElevation>
          Done
        </DoneButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default SuccessDialog;
